import React from 'react';
import companyLogo from '../assets/code-cube.io-marketing-observability-logo.png';


export const CompanyLogo = () => {
    return(
        <div className='text-center'>
            <img className='my-4' src={companyLogo} alt="Company logo" height={45} />
        </div>
    )
}
